
export class MenuItemModel {
    label:string;
    url:string;
    image:string;
    active?:boolean;
    submenu:MenuItemModel[] | null;
    status:boolean;
  
  }
  
 